import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "icon", "toggle"];
    toggle() {
        const show = this.inputTarget.type === "password";
        this.inputTarget.type = show ? "text" : "password";
        this.iconTarget.setAttribute("name", show ? "eye" : "eye-slash");
        this.toggleTarget.classList.add("is-toggling");
        setTimeout(() => this.toggleTarget.classList.remove("is-toggling"), 120);
    }
}